/* Unik — drop countdown. Reads an ISO datetime with offset from
   the section setting and ticks once a second. */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var target = Date.parse(el.dataset.countdown);
      if (isNaN(target)) return;
      var ms = Math.max(0, target - Date.now());
      var parts = {
        days: Math.floor(ms / 86400000),
        hours: Math.floor(ms / 3600000) % 24,
        mins: Math.floor(ms / 60000) % 60,
        secs: Math.floor(ms / 1000) % 60
      };
      Object.keys(parts).forEach(function (k) {
        var slot = el.querySelector('[data-unit="' + k + '"]');
        if (slot) slot.textContent = pad(parts[k]);
      });
      el.classList.toggle('is-live', ms === 0);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    tick();
    setInterval(tick, 1000);
  });
})();
